import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },

  // pagine singole lazy
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
    data: {
      seo: {
        title:
          'MyVet Diet - Cibo Fresco per Cani a Domicilio prodotto in Italia',
        description:
          'Scopri MyVet Diet: cibo fresco per cani a domicilio, 100% prodotto in Italia. Piani pasto su misura con ingredienti naturali per un cane sano e felice. Crea il suo menù!',
      },
    },
  },
  {
    path: 'come-funziona',
    loadComponent: () =>
      import('./pages/come-funziona/come-funziona.component').then(
        (m) => m.ComeFunzionaComponent
      ),
    data: {
      seo: {
        title: "MyVet Diet - Come Funziona l'Abbonamento di Cibo Fresco",
        description:
          'MyVet Diet - Scopri come funziona il nostro servizio in 5 semplici step. Personalizza il menù del tuo cane, ricevi la box a casa e gestisci tutto online. Semplice, flessibile e senza vincoli.',
      },
    },
  },
  {
    path: 'opinioni',
    loadComponent: () =>
      import('./pages/opinioni/opinioni.component').then(
        (m) => m.OpinioniComponent
      ),
    data: {
      seo: {
        title:
          'MyVet Diet - Funziona Davvero? Te lo Raccontano i Nostri Clienti',
        description:
          'La prova migliore della nostra qualità sono le storie dei nostri clienti. Leggi le loro opinioni sincere sui risultati ottenuti e sulla semplicità del nostro servizio.',
      },
    },
  },
  {
    path: 'ingredienti',
    loadComponent: () =>
      import('./pages/ingredienti/ingredienti.component').then(
        (m) => m.IngredientiComponent
      ),
    data: {
      seo: {
        title: 'MyVet Diet - Ricette per Cani con Ingredienti Freschi',
        description:
          'Scopri le nostre ricette sane e gustose per cani. Scegli tra manzo ricco di energia, pollo ad alta digeribilità, merluzzo per pelle e pelo, e maiale dal gusto intenso. ',
      },
    },
  },
  {
    path: 'nostri-nutrizionisti',
    loadComponent: () =>
      import(
        './pages/nostri-nutrizionisti/nostri-nutrizionisti.component'
      ).then((m) => m.NostriNutrizionistiComponent),
    data: {
      seo: {
        title:
          'MyVet Diet - Chi Siamo: Esperti per Amore, Veterinari per Scelta',
        description:
          "Non siamo solo un'azienda. Siamo un team di veterinari e amanti dei cani. Leggi la nostra filosofia basata su amore, scienza e ingredienti di altissima qualità.",
      },
    },
  },

  // sezione Blog lazy (rotte figlie)
  {
    path: 'blog',
    loadChildren: () => BLOG_ROUTES,
    data: {
      seo: {
        title:
          'MyVet Diet - Il Blog: La Scienza della Nutrizione Spiegata Semplice',
        description:
          'Approfondisci i temi più importanti per la salute del tuo cane. Il nostro blog è la tua fonte di consigli affidabili su alimentazione, cura e comportamento, basati sulla scienza.',
      },
    },
  },

  {
    path: ':articolo-main',
    loadComponent: () =>
      import('./pages/salute/articolo-main/articolo-main.component').then(
        (m) => m.ArticoloMainComponent
      ),
  },

  { path: '**', redirectTo: 'home' },
];

export const BLOG_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/blog/blog.component').then((m) => m.BlogComponent),
  },

  {
    path: 'post/:slug',
    loadComponent: () =>
      import('./pages/blog/articolo/articolo.component').then(
        (m) => m.ArticoloComponent
      ),
  },
  {
    path: ':categoria/:articolo',
    loadComponent: () =>
      import('./pages/blog/articolo/articolo.component').then(
        (m) => m.ArticoloComponent
      ),
  },
  {
    path: ':categoria',
    loadComponent: () =>
      import('./pages/blog/categoria/categoria.component').then(
        (m) => m.CategoriaComponent
      ),
  },
];
